import { generateClient } from 'aws-amplify/data';

export const guestClient = generateClient({ authMode: 'iam' });
export const authClient = generateClient({ authMode: 'userPool' });
